import { AmplifyCore, commonEnums as enums } from '@codametrix/ui-common';

/**
 * Resources a user must hold to reach native analytics. `native_analytics` is the master toggle
 * (a resource_flag, so it can be switched per tenant); the Tableau leaf is the per-dashboard role
 * gate that the embedded dashboard already uses, so both renderers share one set of role grants.
 *
 * The nav item (core/navigation.tsx) and the /cmx/automation-dashboard/ route (apps/cmx/CMx.tsx)
 * both read this list so they cannot disagree.
 */
export const NATIVE_ANALYTICS_REQUIRED_LEAVES: string[] = [
  enums.ResourceId.CASE_ANALYTICS
];

/**
 * The analytics API gates on the `analytics` authority, not on CMx resources, so the UI has to
 * enforce this itself or a direct URL would render the view for anyone logged in.
 */
export const canViewNativeAnalytics = (
  activeContext: CMxAPI.OrganizationContext | null | undefined,
  serviceLineName: string
): boolean =>
  !!activeContext &&
  [enums.ResourceId.NATIVE_ANALYTICS, ...NATIVE_ANALYTICS_REQUIRED_LEAVES].every(
    resourceId =>
      AmplifyCore.benchEditable.isResourceAllowed(
        activeContext,
        resourceId,
        serviceLineName
      )
  );

/** Read from live state on every render, never captured. */
export const selectCanViewNativeAnalytics = (state: any): boolean =>
  canViewNativeAnalytics(
    state?.ui?.context?.activeContext,
    state?.ui?.serviceLine?.name ?? ''
  );
